import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import PropTypes from "prop-types";
import React from "react";

import { fileType } from "../../../common/AppConstant";
import { addByteUnit } from "../../../common/AppUtil";
import useStyles from "../useStyles";

/**
 * PressManagementActionTableコンポーネント.
 *
 * @param {object} fileInfo 選択済みファイル情報
 * @param {function} onCancel 選択済みファイルの解除ボタン押下時の処理
 * @return {object} コンポーネント
 */
function PressManagementActionTable(props) {
  // 引数
  const {
    // 選択済みファイル情報
    fileInfo,
    // 選択ファイルの解除ボタン押下時の処理
    onCancel,
  } = props;

  // スタイル
  const styles = useStyles();

  return (
    <TableContainer className={styles.tableContainerSmall}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              className={`${styles.tableHeader} ${styles.fileNameTableCellSmall}`}
            >
              ファイル名
            </TableCell>
            <TableCell
              className={`${styles.tableHeader} ${styles.fileSizeTableCellSmall}`}
            >
              サイズ
            </TableCell>
            <TableCell className={styles.iconTableCell} />
          </TableRow>
        </TableHead>
        <TableBody>
          {!fileInfo ? (
            <TableRow>
              <TableCell>-</TableCell>
              <TableCell>-</TableCell>
              <TableCell />
            </TableRow>
          ) : (
            <TableRow
              key={`FileActionTable_${
                fileInfo.fileName ? fileInfo.fileName : fileInfo.name
              }`}
            >
              <TableCell>
                <div className={styles.wordBreak}>
                  {fileInfo.fileName || fileInfo.name}
                </div>
              </TableCell>
              <TableCell>
                {addByteUnit(fileType.file, fileInfo.fileSize || fileInfo.size)}
              </TableCell>
              <TableCell className={styles.iconTableCell}>
                <IconButton
                  className={styles.canceliconButton}
                  color="inherit"
                  onClick={() => onCancel(fileInfo)}
                >
                  <Cancel fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

PressManagementActionTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fileInfo: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
};

PressManagementActionTable.defaultProps = {
  fileInfo: undefined,
};

export default PressManagementActionTable;
